import { render, staticRenderFns } from "./activation-code.vue?vue&type=template&id=275164b2&scoped=true&"
import script from "./activation-code.vue?vue&type=script&lang=js&"
export * from "./activation-code.vue?vue&type=script&lang=js&"
import style0 from "./activation-code.vue?vue&type=style&index=0&id=275164b2&scoped=true&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275164b2",
  null
  
)

export default component.exports